module.exports = __webpack_public_path__ + "static/fonts/dfyuanstd-w3.6e4ca72.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/dfyuanstd-w3.otf
// module id = c5Af
// module chunks = 1